import gql from 'graphql-tag';
import apollo from '../../../services/apollo';

const GIVE_SYSTEM_USER_EXTERNAL_SUPPORT_ROLE = gql`
mutation giveSystemUserExternalSupportRoleInAccount($accountId: ID!) {
    giveSystemUserExternalSupportRoleInAccount(accountId: $accountId){
        id
    }
}
 `;

export const giveSystemUserExternalSupportRoleInAccount = accountId => apollo
  .mutate({
    mutation: GIVE_SYSTEM_USER_EXTERNAL_SUPPORT_ROLE,
    variables: {
      accountId,
    },
    refetchQueries: ['getViewerAccounts', {
      query: 'getHierarchy',
      variables: { accountId },
    }],
    awaitRefetchQueries: true,
  })
  .then(res => res.data);


export default {
  GIVE_SYSTEM_USER_EXTERNAL_SUPPORT_ROLE,
};
